import styled, { css } from 'styled-components'
// views
import { ButtonsWrapper } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
import { DocOrLinkWrapper } from 'components/FormElements/DocumentOrLink/Risk/views'
import { AddFieldButtonWrapper } from '../AddFieldButton/views'
// themes
import { colors } from 'themes'

const TableContainer = styled.div`
  background-color: ${colors.gray190};
  border-radius: 4px;
  min-height: 64px;
  position: relative;
  display: flex;
  font-size: 14px;

  ::-webkit-scrollbar-track {
    background: ${colors.gray190};
  }

  ::-webkit-scrollbar-thumb {
    border-color: ${colors.gray190};
  }

  > ${ButtonsWrapper} {
    z-index: 10;
  }
`

const DragHandle = styled.span`
  margin-left: 8px;
  padding-top: 8px;
`

const TableContent = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
  padding: 0 8px 8px;
  width: 100%;

  //  column
  > div > div {
    flex: 0 0 auto;
    width: 200px;
  }

  // add column button
  ${AddFieldButtonWrapper} {
    align-items: start;
    background: ${colors.gray190};
    border-radius: 0;
    display: flex;
    height: 76px;
    margin: 0;
    min-width: unset;
    padding: 12px;
    padding-top: 26px;
    position: sticky;
    right: -8px;
    top: 0;
    z-index: 9;
  }

  ${DocOrLinkWrapper} {
    min-height: 32px;
  }

  .MuiInputLabel-formControl,
  .responseTypeLabel {
    display: none;
  }

  .switch-wrapper {
    > div > div {
      height: 32px;
      justify-content: center;
    }
  }

  .react-select__single-value {
    white-space: normal;
  }

  .MuiFormControl-root > div {
    margin-top: 0;
  }
`

const DroppableContainer = styled.div`
  display: flex;
  height: fit-content;
`

const DraggableContainer = styled.div<{ $stickyLeft?: number }>`
  background-color: ${colors.gray190};
  display: flex;
  flex-direction: column;

  ${({ $stickyLeft }) =>
    $stickyLeft !== undefined &&
    css`
      position: sticky;
      left: ${$stickyLeft - 8}px;
      z-index: 5;
    `}
`

const FloatingScrollbar = styled.div<{ $left: number; $width: number }>`
  position: fixed;
  bottom: 0;
  left: ${({ $left }) => $left}px;
  width: ${({ $width }) => $width}px;
  height: 12px;
  overflow-x: scroll;
  overflow-y: hidden;
  z-index: 1200;

  ::-webkit-scrollbar {
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${colors.gray190};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.25);
    border-radius: 4px;

    &:hover {
      background: rgba(0, 0, 0, 0.4);
    }
  }
`

export { TableContent, TableContainer, DroppableContainer, DraggableContainer, DragHandle, FloatingScrollbar }
